import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router'

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(
    private router : Router
  ) { }

  ngOnInit() {
  }

  home(){
    this.router.navigateByUrl('/');
  }

  bikeshopWizard(){
    this.router.navigateByUrl('/signup-wizard');
  }

  clubsWizard(){
    this.router.navigateByUrl('/club-setup-wizard');
  }

}
